import { axiosInstance } from "./api";

export const getCurrentUser = async () => {
  const res = await axiosInstance.get("/api/v2/user/getCurrent");
  return res.data;
};

export type TUpdateProfile = {
  lastName: string;
  firstName: string;
  middleName: string;
  phone: string;
  email: string;
};

export const updateProfile = async (props: TUpdateProfile) => {
  const res = await axiosInstance.post("/api/v2/user/updateProfile", props);
  return res.data;
};

export type TUpdatePassword = {
  password: string;
};

export const updatePassword = async (props: TUpdatePassword) => {
  const res = await axiosInstance.post("/api/v2/user/updatePassword", props);
  return res.data;
};

export type TAddAddress = {
  address: string;
};

export const addAddress = async (props: TAddAddress) => {
  const res = await axiosInstance.post("/api/v2/address", props);
  return res.data;
};

export const removeAddress = async (id: string) => {
  const res = await axiosInstance.delete(`/api/v2/address/remove/${id}`);
  return res.data;
};

export const setDefaultAddress = async (id: string) => {
  const res = await axiosInstance.patch(`/api/v2/address/setDefault/${id}`);
  return res.data;
};

export type TUpdateRequisites = {
  orgName: string;
  orgNameShort: string;
  orgAddress: string;
  orgInn: string;
  orgKpp: string;
};

export const updateRequisites = async (props: TUpdateRequisites) => {
  const res = await axiosInstance.post("/api/v2/user/updateRequisites", props);
  return res.data;
};

export type TResetPassword = {
  email: string;
};

export const resetPassword = async (props: TResetPassword) => {
  const res = await axiosInstance.post("/api/v2/user/passwordRecovery", props);
  return res.data;
};

export type TNewPassword = {
  code: string;
  password: string;
};

export const newPassword = async (props: TNewPassword) => {
  const res = await axiosInstance.post("/api/v2/user/newPassword", props);
  return res.data;
};
